/**
 * 反馈历史页懒加载壳（14.35c；FeedbackLazy 同构）：低频页不进首屏 bundle。
 */
import { useLazyModule } from './useLazyModule';

export function FeedbackHistoryLazy() {
  const { mod } = useLazyModule(() => import('./FeedbackHistoryPage'));
  if (mod === null) return <div data-testid="feedback-history-loading-shell">加载中…</div>;
  return <mod.FeedbackHistoryPage />;
}
